export function VehicleVisualsModalCtrl (
  $uibModalInstance,
  $scope,
  $translate,
  blockUI,
  messages,
  VehicleVisuals
) {

  $scope.frontBlock     = blockUI.instances.get('frontBlock');
  $scope.flipped        = false;
  $scope.VehicleVisuals = VehicleVisuals;
  $scope.selectedItems  = [];

  $scope.tableSettings = {
    columns: [
      {
        classes: 'text-left',
        field  : 'title',
        header : {
          text: $translate.instant('VEHICLE_VISUALS_SPACE.PART')
        }
      },
      {
        classes: 'text-left',
        field  : 'description',
        header : {
          text: $translate.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
        }
      }
    ],
    empty: {
      text: $translate.instant('GENERAL_SPACE.STATUS.NO_RESULTS')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.onRowClick = function () {
    $scope.selectedItems = $scope.VehicleVisuals.catalog.search.results.filter((row) => row.selected);
  };

  $scope.onRowDoubleClick = function (event) {
    $scope.selectedItems = [event.row];
    $scope.select();
  };

  $scope.flip = function () {
    $scope.flipped = !$scope.flipped;

    $scope.$emit('flipModal');
  };

  $scope.refreshCatalog = function () {
    $scope.frontBlock.start();

    VehicleVisuals.getCatalog()
    .finally(() => {
      $scope.frontBlock.stop();
    });
  };

  $scope.search = function () {
    $scope.VehicleVisuals.search()
    .then(() => {
      $scope.searched = true;
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.select = function () {
    const selection = $scope.flipped ?
    $scope.selectedItems[0] :
    $scope.VehicleVisuals.catalog.defect || $scope.VehicleVisuals.catalog.part || $scope.VehicleVisuals.catalog.system;

    $uibModalInstance.close(selection);
  };
}